import { render, staticRenderFns } from "./RadvizPage2.vue?vue&type=template&id=1ec19495&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RadvizPage2.vue"
export default component.exports